const BOT_PATTERNS = [
  /bot/i, /crawl/i, /spider/i, /slurp/i, /facebookexternalhit/i,
  /linkedinbot/i, /twitterbot/i, /whatsapp/i, /telegrambot/i,
  /googlebot/i, /bingbot/i, /yandexbot/i, /baiduspider/i,
  /duckduckbot/i, /semrushbot/i, /ahrefsbot/i, /mj12bot/i,
  /dotbot/i, /petalbot/i, /bytespider/i, /gptbot/i,
  /headlesschrome/i, /phantomjs/i, /puppeteer/i, /selenium/i,
  /lighthouse/i, /pagespeed/i, /chrome-lighthouse/i,
  /dataforseo/i, /applebot/i, /ia_archiver/i,
  /meta-externalagent/i, /meta-externalfetcher/i,
];

export function isBot() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (!ua) return true;
  return BOT_PATTERNS.some((pattern) => pattern.test(ua));
}
